<template>
    <div>
        <!-- eslint-disable vue/no-v-html -->
        <div
            :class="[appearance ? `${appearance}` : 'max-md:container', 'editorial']"
            v-html="evaluateTextForScripts(item.text)"
        ></div>
        <!-- eslint-enable -->
    </div>
</template>

<script>
import { evaluateTextForScripts } from '@/helpers/script';

export default {
    name: 'WidgetEditorial',
    props: {
        item: {
            type: Object,
            required: true,
        },
        appearance: {
            type: String,
            required: false,
            default: null,
        },
    },
    mounted() {
        this.loadReport();
    },
    methods: {
        evaluateTextForScripts,
        loadExternalScript(url) {
            return new Promise((resolve, reject) => {
                const script = document.createElement('script');
                script.onload = () => {
                    resolve();
                };
                script.onerror = () => {
                    reject();
                };
                script.setAttribute('src', url);
                document.head.appendChild(script);
            });
        },
        loadReport() {
            const reportData = sdWindow?.report;
            const reportContainer = document.getElementById('reportContainer');
            if (reportContainer != null) {
                if (reportData != null) {
                    Promise.all([
                        this.loadExternalScript('https://cdn.jsdelivr.net/npm/jquery@3.7.1/dist/jquery.min.js'),
                        this.loadExternalScript(
                            'https://cdn.jsdelivr.net/npm/powerbi-client@2.23.1/dist/powerbi.min.js',
                        ),
                    ]).then(() => {
                        const { models } = window['powerbi-client'];
                        const basicFilter = {
                            $schema: 'http://powerbi.com/product/schema#basic',
                            target: {
                                table: 'DimUser',
                                column: 'UserId',
                            },
                            displaySettings: {
                                isLockedInViewMode: true,
                            },
                            operator: 'In',
                            values: [reportData.encodeId],
                        };
                        const embedConfiguration = {
                            id: import.meta.env.MIX_POWER_BI_REPORT_ID,
                            embedUrl: reportData.embedUrl,
                            tokenType: models.TokenType.Embed,
                            type: 'report',
                            accessToken: reportData.token,
                            filters: [basicFilter],
                            settings: {
                                panes: {
                                    filters: {
                                        visible: false,
                                    },
                                    pageNavigation: {
                                        visible: false,
                                    },
                                },
                                visualSettings: {
                                    visualHeaders: [
                                        {
                                            settings: {
                                                visible: false,
                                            },
                                        },
                                    ],
                                },
                            },
                            permisssions: models.Permissions.Read,
                        };
                        // eslint-disable-next-line no-undef
                        const report = powerbi.embed(reportContainer, embedConfiguration);
                        report.setFilters([basicFilter]);
                    });
                } else {
                    reportContainer.parentNode.removeChild(reportContainer);
                }
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.editorial {
    :deep(h1) {
        @apply font-display-3 break-words;
        @screen md {
            @apply font-display-2;
        }
        @screen lg {
            @apply font-display-1;
        }
    }

    :deep(h2) {
        @apply font-subtitle-3 break-words;
        @screen md {
            @apply font-subtitle-2;
        }
        @screen lg {
            @apply font-subtitle-1;
        }
    }

    :deep(h3) {
        @apply font-body-1-medium break-words;
        @screen md {
            @apply font-subtitle-3;
        }
        @screen lg {
            @apply font-subtitle-2;
        }
    }

    :deep(h4) {
        @apply font-body-2-medium break-words;
        @screen md {
            @apply font-body-1-medium;
        }
        @screen lg {
            @apply font-subtitle-3;
        }
    }

    :deep(p) {
        @apply text-slate-600;
        font-size: 1.125rem;
        line-height: 1.875rem;
        a {
            @apply whitespace-normal break-words text-blue-600;
        }
        img {
            display: inline;
        }
    }

    :deep(img) {
        height: auto !important;
    }

    :deep(ol) {
        list-style: decimal;
        @apply ml-4;
    }

    :deep(ul) {
        list-style: inside;
    }
}
</style>
